import vOutsideEvents from 'vue-outside-events';
import Vue from 'vue';

export default (vue?: typeof Vue) => {
	(vue || Vue).use(vOutsideEvents);
	return {};
};
